import React, { Component } from "react";
import { Link } from "react-router-dom";
import ContactForm2 from "../CommentForm2";
import "./style.css";
import cd_1 from "../../images/Attorneys-single/img-1.jpg";
import cd_5 from "../../images/studies/1.jpg";
import cd_6 from "../../images/studies/2.jpg";
import cd_7 from "../../images/studies/3.jpg";

class ScheduleMeeting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      divExpanded: null,
    };
  }

  // React method to expand only 1 div and collapse others.
  toggleDivVisibility = (divId) => {
    this.setState((prevState) => ({
      divExpanded: prevState.divExpanded === divId ? null : divId,
    }));
  };

  // Defining the width and height of the iFrame's that render's Calendly URLs.
  iframeWidth = "700vw";
  // iFrame is statically loaded, once loaded its height cannot be changed. So setting a large height value to accommodate all Calendly information. .
  iframeHeight = 1500;

  render() {
    return (
      <div className="Attorneys-content-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="Attorneys-area">
                <div className="container att-s">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="Attorneys-info">
                        <div className="Attorneys-content">
                          <h3>Book a Meeting</h3>
                        </div>
                        <div className="info-outer">
                          <ul className="info">
                            <li>
                              <span>Name: </span> B Turner Law
                            </li>
                            <li>
                              <span>Practice Area: </span>Real Estate, Wills,
                              Corporate
                            </li>
                            <li>
                              <span>Address: </span>1200 St. Laurent Blvd, Unit
                              517 Ottawa, ON K1K 3B8
                            </li>
                            <li>
                              <span>Phone: </span> (613) 680-6804{" "}
                            </li>
                            <li>
                              <span>Email: </span>info@bturnerlaw.ca
                            </li>
                            <li>
                              <span>Fax: </span> (613) 680-4604
                            </li>
                          </ul>
                          <ul className="social">
                            <li>
                              <a href={"https://www.facebook.com/bturnerlaw/"} target="_blank">
                                <i className="fa fa-facebook"></i>
                              </a>
                            </li>
                            <li>
                              <a href={"https://twitter.com/babette_t"} target="_blank">
                                <i className="fa fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href={"https://www.linkedin.com/in/babette-turner-277a31292/"} target="_blank">
                                <i className="fa fa-linkedin"></i>
                              </a>
                            </li>
                            <li>
                              <a href={"https://www.instagram.com/lawyerbabette/"} target="_blank">
                                <i
                                  className="fa fa-instagram"
                                ></i>
                              </a>
                            </li>
                            <li>
                              <a href={"https://www.tiktok.com/@lawyerbabette"} target="_blank">
                                <i
                                    className="fa fa-tiktok"
                                ></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h1>Schedule a Meeting</h1>
              <ul>
                <li>
                  <h4 onClick={() => this.toggleDivVisibility(1)}>
                    Document e-signing
                  </h4>
                </li>
                <li>
                  <h4 onClick={() => this.toggleDivVisibility(2)}>
                    Law Meetings
                  </h4>
                  <p>*Note: Please choose PACTIMA and not Zoom for meetings involving e-signing documents.</p>
                </li>
                <li>
                  <h4 onClick={() => this.toggleDivVisibility(3)}>
                    Calendly Home
                  </h4>
                </li>
              </ul>
              {/*Calendly Components*/}

              {this.state.divExpanded === 1 && (
                <div class="calendlyExternal">
                  <iframe
                    src="https://calendly.com/bturnerlaw_meetings/b-turner-law-document-e-signing"
                    width={this.iframeWidth}
                    height={this.iframeHeight}
                  ></iframe>
                </div>
              )}

              {this.state.divExpanded === 2 && (
                <div class="calendlyExternal">
                  <iframe
                    src="https://calendly.com/bturnerlaw_meetings/b-turner-law-meetings"
                    width={this.iframeWidth}
                    height={this.iframeHeight}
                  ></iframe>
                </div>
              )}

              {this.state.divExpanded === 3 && (
                  <div class="calendlyExternal">
                    <iframe
                        src="https://calendly.com/bturnerlaw_meetings"
                        width={this.iframeWidth}
                        height={this.iframeHeight}
                    ></iframe>
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ScheduleMeeting;
